export default () => ({
  cardContent: {
    height: '100%',
  },
});
